import { render, staticRenderFns } from "./LogoSettings.vue?vue&type=template&id=0cbc8733"
import script from "./LogoSettings.vue?vue&type=script&lang=ts"
export * from "./LogoSettings.vue?vue&type=script&lang=ts"
import style0 from "./LogoSettings.vue?vue&type=style&index=0&id=0cbc8733&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cbc8733')) {
      api.createRecord('0cbc8733', component.options)
    } else {
      api.reload('0cbc8733', component.options)
    }
    module.hot.accept("./LogoSettings.vue?vue&type=template&id=0cbc8733", function () {
      api.rerender('0cbc8733', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/LogoSettings.vue"
export default component.exports